import { Input, Component, ViewChild } from "@angular/core";
import { IExpandableItemConfigSet } from "../../interfaces/iconfigurationset";
import { IPublicationHistory } from "../../interfaces/ipublicationhistory";
import { Metadata, SourceMetadata } from "../../models/Metadata";

@Component({
    selector: "country-publicationhistory",
    templateUrl: "./countrypublicationhistory.component.html",
    standalone: false
})
export class CountryPublicationHistoryComponent {
    @Input() content!: IExpandableItemConfigSet;
    @Input() countryCode!: string;

    getHierarchyDisplayText(nodes: string[]): string {
        let text: string = "";
        let first: boolean = true;
        if (nodes && nodes.length > 0) {
            nodes.forEach(node => {
                if (!first) {
                    text = `${text} > `;
                }
                text = `${text}${node}`;
                first = false;
            });
        }
        return text;
    }

    // Helper method to safely check if metadata has URL property
    hasUrl(metadata: Metadata): boolean {
        return 'url' in metadata;
    }

    // Helper method to safely get URL from metadata
    getUrl(metadata: Metadata): string {
        return (metadata as SourceMetadata).url;
    }
}
